import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import logo from '@/assets/logo-optimized.png';

export function LandingNavbar() {
  const { user } = useAuth();

  return (
    <header className="sticky top-0 z-50 border-b bg-card/80 backdrop-blur-md">
      <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img src={logo} alt="RepriScan" className="h-14 w-14" />
          <span className="font-bold text-xl">RepriScan</span>
        </Link>
        
        <nav className="flex items-center gap-6">
          <Link 
            to="/pricing" 
            className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors hidden sm:block"
          >
            Plans & Tarifs
          </Link>
          
          {user ? (
            <Link to="/dashboard">
              <Button size="sm">
                Mon Dashboard
              </Button>
            </Link>
          ) : (
            <Link to="/auth">
              <Button variant="outline" size="sm">
                Connexion
              </Button>
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
